
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Pop from "@/views/ai-builder-component/components/blue-pop.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import HinaCheckboxGroup from "@/views/ai-builder-component/baseComponent/hina-checkbox-group.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import HinaSelect from "@/views/ai-builder-component/baseComponent/hina-select.vue";
import HinaInput from "@/views/ai-builder-component/baseComponent/hina-input.vue";
import HinaTextarea from "@/views/ai-builder-component/baseComponent/hina-textarea.vue";
import HinaInputNumber from "@/views/ai-builder-component/baseComponent/hina-input-number.vue";
import HinaEmpty from "@/views/ai-builder-component/baseComponent/hina-empty.vue";
import {
  ExamV2Custom,
  StructExamDimensionConfig,
  StructExamQuestionConfig,
  StructExamRandomConfig
} from "@/lib/model/exambuilder/exam-v2";
import {
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";
import {
  EnumQuestionAppendAskType,
  EnumQuestionAppendConditionType,
  ReplyFixedSpeechList,
  RuleAsk
} from "@/lib/model/exambuilder/ai-ask";
import { AskConfig } from "@/lib/model/exambuilder/exam-component/question";
import _ from "lodash";

@Component({
  components: {
    HinaEmpty,
    HinaInputNumber,
    HinaTextarea,
    HinaInput,
    HinaSelect,
    HinaSwitch,
    HinaCheckboxGroup,
    HinaRadioGroup,
    Pop,
    InputNumberV3,
    IntroduceCard
  }
})
export default class AiAsk extends Vue {
  @Prop() exam!: ExamV2Custom; // 组件数据

  mounted() {
    console.log("🚀 ~ AiAsk ~ mounted ~ this.exam:", this.exam);
  }

  needDefaultText = false; // 是否需要兜底话术，如果开启则兜底话术必填

  initSetNeedDefaultText() {
    this.needDefaultText = !!this.activeQuestion.appendAskConfig.defaultText;
  }

  get isDefaultTextRequired() {
    return this.needDefaultText;
  }

  // 默认追问系数都是 1
  appendScorePercent = 1;
  // 默认最大追问轮次为 1
  appendMaxAskNumber = 1;

  // 固定题目的可以追问的问题列表（视频题）
  get askQuestionList() {
    const examQuestionConfigList = this.examQuestionConfigList.filter(item =>
      this.isAppendAsk(item.questionId)
    );
    if (examQuestionConfigList.length > 0) {
      examQuestionConfigList.forEach(item => {
        if (item.appendMaxAskNumber == 0) {
          item.appendMaxAskNumber = this.appendMaxAskNumber;
        }
        item.appendScorePercent = this.appendScorePercent;
      });
    }
    console.log(
      "🚀 ~ AiAsk ~ getaskQuestionList ~ examQuestionConfigList:",
      examQuestionConfigList
    );
    return examQuestionConfigList;
  }

  // 抽题组可以追问的组列表（视频题）
  get randomAskQuestionList() {
    const examRandomConfigList = this.examRandomConfigList.filter(item =>
      item.isVideoQuestion()
    );
    if (examRandomConfigList.length > 0) {
      examRandomConfigList.forEach(item => {
        if (item.examQuestionConfig.appendMaxAskNumber == 0) {
          item.examQuestionConfig.appendMaxAskNumber = this.appendMaxAskNumber;
        }
        item.examQuestionConfig.appendScorePercent = this.appendScorePercent;
      });
    }
    console.log(
      "🚀 ~ AiAsk ~ randomAskQuestionList ~ examRandomConfigList:",
      examRandomConfigList
    );
    return examRandomConfigList;
  }

  // 是否支持追问功能
  isAppendAsk(questionId: number): boolean {
    const question = this.selectedQuestionList.find(
      q => q.questionId === questionId
    );
    return question?.isVideoQuestion() || false;
  }

  // 抽题组题干
  getRandomText(questionGroup: StructExamRandomConfig, index: number) {
    if (!questionGroup || !questionGroup.questionIdList) return "";
    return `组${index + 1}：${
      questionGroup.questionIdList.length > 0
        ? questionGroup.name || "抽题组卷题"
        : "抽题组卷题"
    } | ${questionGroup.questionIdList.length}抽${
      questionGroup.questionNumber
    } | ${
      questionGroup.questionIdList.length > 0
        ? questionGroup.getQuestionTypeText() || "未选择题型"
        : "未选择题型"
    }`;
  }

  // 固定组题干
  getQuestionText(questionId: number, index: number) {
    const question = this.selectedQuestionList.find(
      q => q.questionId === questionId
    );

    return question ? `${index + 1}. ${question.descTextOnly}` : "";
  }

  // 追问开关
  handleChangeAsk(val: number, item: StructExamQuestionConfig, index: number) {
    if (val === 1) {
      this.showRules(index);
    } else {
      // item.appendAskConfig.ruleList = [];
    }
  }

  // 弹窗
  rulesDialog = false;
  activeIndex = -1;

  activeQuestion = new StructExamQuestionConfig();
  getActiveQuestion() {
    if (this.isRandom) {
      this.activeQuestion = _.cloneDeep(
        this.randomAskQuestionList[this.activeIndex]?.examQuestionConfig ||
          new StructExamQuestionConfig()
      );
    } else {
      this.activeQuestion = _.cloneDeep(
        this.askQuestionList[this.activeIndex] || new StructExamQuestionConfig()
      );
    }
  }

  get activeQuestionAskAppendConfigRuleList() {
    return this.activeQuestion.appendAskConfig?.ruleList || [];
  }

  clearActiveQuestion() {
    this.activeQuestion = new StructExamQuestionConfig();
  }

  // 点击【使用】按钮时，将配置信息更新回 examRandomConfigList 或者 askQuestionList 中
  activeQuestionSetExam() {
    if (this.isRandom) {
      this.examRandomConfigList[
        this.activeIndex
      ].examQuestionConfig = _.cloneDeep(this.activeQuestion);
      this.randomAskQuestionList[
        this.activeIndex
      ].examQuestionConfig = _.cloneDeep(this.activeQuestion);
    } else {
      const examQuestionConfigIndex = this.examQuestionConfigList.findIndex(
        item => item.questionId == this.activeQuestion.questionId
      );
      this.examQuestionConfigList[examQuestionConfigIndex] = _.cloneDeep(
        this.activeQuestion
      );
      this.askQuestionList[this.activeIndex] = _.cloneDeep(this.activeQuestion);
    }
  }

  // 如果不存在追问规则的时候，默认给三条规则
  defaultRuleAskConfig() {
    const getFirstReplyFixedSpeechList = () => {
      const result = [];
      for (let i = 0; i < 3; i++) {
        const temp = new ReplyFixedSpeechList().assign({
          roundNumber: i + 1,
          replyTextList: [
            "没有识别到你的回答，可以再回答一次吗？",
            "抱歉，没有听到你的回答，可以再回答一次吗？",
            "你好像没有说话，请你再回答一次好吗？"
          ],
          loading: false
        });
        result.push(temp);
      }
      return result;
    };
    const getSecondReplyFixedSpeechList = () => {
      const result = [];
      for (let i = 0; i < 3; i++) {
        const temp = new ReplyFixedSpeechList().assign({
          roundNumber: i + 1,
          replyTextList: [
            "你的回答过于简短，可以回答地更详细一些吗？",
            "你谈到的内容比较少，还有没有其他要补充的信息？",
            "你能否回答的更详细一些，以便我们加深对你的了解？"
          ],
          loading: false
        });
        result.push(temp);
      }
      return result;
    };

    const firstRuleAsk = new RuleAsk().assign({
      conditionType: EnumQuestionAppendConditionType.Count,
      type: EnumQuestionAppendAskType.EnumQuestionAppendAskTypeConst,
      wordLimit: [0, 1],
      replyFixedSpeechList: getFirstReplyFixedSpeechList()
    });

    console.log("🚀 ~ AiAsk ~ firstRuleAsk ~ firstRuleAsk:", firstRuleAsk);

    const secondRuleAsk = new RuleAsk().assign({
      conditionType: EnumQuestionAppendConditionType.Count,
      type: EnumQuestionAppendAskType.EnumQuestionAppendAskTypeConst,
      wordLimit: [1, 10],
      replyFixedSpeechList: getSecondReplyFixedSpeechList()
    });

    const thirdRuleAsk = new RuleAsk().assign({
      conditionType: EnumQuestionAppendConditionType.Count,
      type: EnumQuestionAppendAskType.EnumQuestionAppendAskTypeAIGC,
      wordLimit: [10, 500]
    });

    return [firstRuleAsk, secondRuleAsk, thirdRuleAsk];
  }

  showRules(index: number) {
    this.activeIndex = index;
    this.getActiveQuestion();
    this.initSetNeedDefaultText();

    console.log(
      "🚀 ~ AiAsk ~ showRules ~ this.activeQuestion.appendAskConfig.ruleList.length:",
      this.activeQuestion.appendAskConfig.ruleList.length
    );
    if (!this.activeQuestion.appendAskConfig.ruleList.length) {
      const ruleAsk = this.defaultRuleAskConfig();
      console.log("🚀 ~ AiAsk ~ showRules ~ ruleAsk:", ruleAsk);
      this.activeQuestion.appendAskConfig.ruleList.push(...ruleAsk);
    }

    this.rulesDialog = true;
  }

  cancelRule() {
    this.activeIndex = -1;
    this.rulesDialog = false;
    this.clearActiveQuestion();
  }

  checkBeforeSubmitRule() {
    if (this.isDefaultTextRequired) {
      if (!this.activeQuestion.appendAskConfig.defaultText) {
        this.$message.error("兜底话术不能为空");
        return false;
      }
      if (this.activeQuestion.appendAskConfig.ruleList.length > 0) {
        for (const item of this.activeQuestion.appendAskConfig.ruleList) {
          if (item.conditionType === EnumQuestionAppendConditionType.Count) {
            if (item.wordLimit.length < 2) {
              this.$message.error("请设置回答字数范围");
              return false;
            } else {
              for (const rWordLimit of item.wordLimit) {
                if (rWordLimit === "") {
                  this.$message.error("请设置回答字数范围");
                  return false;
                }
              }
            }
          }
          // 固定话术
          if (
            item.type ===
            EnumQuestionAppendAskType.EnumQuestionAppendAskTypeConst
          ) {
            // 如果 item.replyCheckpointList 中的 replyTextList 有空的，例如[""]，那么就提示报错
            if (item.replyFixedSpeechList.length > 0) {
              for (const rItem of item.replyFixedSpeechList) {
                // 判断 rItem.replyTextList 中的每个元素是否为空
                if (rItem.replyTextList.length > 0) {
                  for (const rItemText of rItem.replyTextList) {
                    if (!rItemText) {
                      this.$message.error("固定话术不能为空");
                      return false;
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      // 如果兜底话术开关是关的，那么清空兜底话术
      this.activeQuestion.appendAskConfig.defaultTextList = [""];
    }
    return true;
  }

  submitRule() {
    if (!this.checkBeforeSubmitRule()) return;
    this.activeQuestion.appendAskConfig.ruleList.forEach(rItem => {
      rItem.replyFixedSpeechList.forEach((item, index) => {
        item.roundNumber = index + 1;
      });
    });

    this.activeQuestion.needAskAppend = 1;
    this.activeQuestionSetExam();
    this.activeIndex = -1;
    this.rulesDialog = false;
    this.clearActiveQuestion();
  }

  // 追问条件
  conditionTypeOptions = [
    { name: "固定100%触发", value: 1 },
    { name: "按回答字数触发", value: 2 }
  ];

  handleChangeConditionType(rule: RuleAsk) {
    if (rule.conditionType === 1) {
      rule.type = 1;
    } else {
      if (rule.wordLimit.length < 2) {
        rule.wordLimit = [0, 500];
      }
    }
  }

  // 话术类型
  typeOptions = [
    { name: "固定话术", value: 1 },
    { name: "AIGC话术", value: 2 }
  ];

  getTypeOptions(conditionType: number) {
    if (conditionType === 1) {
      return [this.typeOptions[0]];
    }

    return this.typeOptions;
  }

  // aigc模型
  aigcTypeOptions = [
    // { name: "GPT追问", value: "GPT" },
    { name: "补全式追问", value: "INFO" },
    { name: "STAR式追问", value: "STAR" },
    { name: "通用", value: "FollowupBotCommon" }
  ];

  // 添加追问demo
  async getAskDemo(ruleIndex: number, askIndex: number) {
    const roundItem = this.activeQuestion.appendAskConfig.ruleList[ruleIndex]
      .replyFixedSpeechList[askIndex];
    roundItem.loading = true;

    try {
      const question = this.selectedQuestionList.find(
        item => item.questionId === this.activeQuestion.questionId
      );

      if (!question) {
        throw "找不到题目";
      }

      const res = await AskConfig.getDemo(question.descTextOnly);

      roundItem.replyTextList = roundItem.replyTextList
        .concat(res)
        .filter(item => !!item);
    } catch (err) {
      this.$message.warning("获取追问demo失败");
    }

    roundItem.loading = false;
  }

  loading = false;
  // 获取兜底话术
  async getDefaultAskDemo(questionId: number) {
    this.loading = true;
    try {
      const question = this.selectedQuestionList.find(
        item => item.questionId === this.activeQuestion.questionId
      );

      if (!question) {
        throw "找不到题目";
      }

      const res = await AskConfig.getDemo(question.descTextOnly);

      this.activeQuestion.appendAskConfig.defaultTextList = this.activeQuestion.appendAskConfig.defaultTextList
        .concat(res)
        .filter(item => !!item);
    } catch (err) {
      this.$message.warning("获取追问demo失败");
    }
    this.loading = false;
  }

  // 新增轮次
  addRoundAsk(ruleIndex: number) {
    this.activeQuestion.appendAskConfig.ruleList[
      ruleIndex
    ].replyFixedSpeechList.push(new ReplyFixedSpeechList());
  }

  delRoundAsk(ruleIndex: number, askIndex: number) {
    this.activeQuestion.appendAskConfig.ruleList[
      ruleIndex
    ].replyFixedSpeechList.splice(askIndex, 1);
  }

  // 规则操作
  moveAsk(direction: number, i: number) {
    const list1 = { ...this.activeQuestion.appendAskConfig.ruleList[i] };
    const list2 = {
      ...this.activeQuestion.appendAskConfig.ruleList[i + direction]
    };

    Object.assign(this.activeQuestion.appendAskConfig.ruleList[i], list2);
    Object.assign(
      this.activeQuestion.appendAskConfig.ruleList[i + direction],
      list1
    );
    this.$forceUpdate();
  }

  // 删除追问规则
  deleteRule(index: number) {
    this.activeQuestion.appendAskConfig.ruleList.splice(index, 1);
  }

  addRule() {
    console.log("🚀 ~ AiAsk ~ addRule ~ addRule:");
    this.activeQuestion.appendAskConfig.ruleList.push(new RuleAsk());
  }

  selectedQuestionList: QuestionV2[] = []; //题目list

  // 固定题目获取每个问题的详细信息
  async getQuestionList() {
    if (this.exam.questionIdList && this.exam.questionIdList.length > 0) {
      const param = {
        questionIdList: this.exam.questionIdList,
        dimensionKeyFilterList: this.exam.dimensionKeyList
      };
      const qo2 = await QuestionV2Object.get(param);
      this.selectedQuestionList = qo2.list;
      if (this.selectedQuestionList.length < this.exam.questionIdList.length) {
        // 数据不一致，有题目被删除，需要重新生成题目list
        this.exam.questionIdList = this.selectedQuestionList.map(question => {
          return question.questionId;
        });
        this.getQuestionList();
        return;
      }

      this.selectedQuestionList.sort((q1, q2) => {
        return (
          this.exam.questionIdList.indexOf(Number(q1.questionId)) -
          this.exam.questionIdList.indexOf(Number(q2.questionId))
        );
      });
    }
  }

  // 随机抽题获取每个组的问题详细信息
  async getRandomQuestionList() {
    if (
      this.exam.examRandomConfigList &&
      this.exam.examRandomConfigList.length > 0
    ) {
      const param = {
        questionIdList: this.exam.examRandomConfigList
          .map(item => item.questionIdList)
          .reduce((pre, cur) => {
            return pre.concat(cur);
          }, []),
        dimensionKeyFilterList: this.exam.dimensionKeyList
      };
      const qo2 = await QuestionV2Object.get(param);
      this.examRandomConfigList.map(config => {
        config.questionList = qo2.list.filter(item => {
          return config.questionIdList.includes(item.questionId);
        });
        return config;
      });
      console.log(
        "🚀 ~ AiAsk ~ getRandomQuestionList ~ examRandomConfigList:",
        this.examRandomConfigList
      );
    }
  }

  examRandomConfigList: StructExamRandomConfig[] = []; //随机抽题题目追问list
  examDimensionConfigList: StructExamDimensionConfig[] = []; //面试维度系数配置list
  examQuestionConfigList: StructExamQuestionConfig[] = []; //固定题目追问list

  async infoAssign(save = false) {
    if (save) {
      this.exam.examDimensionConfigList = this.examDimensionConfigList;
      if (this.isRandom) {
        this.exam.examRandomConfigList = this.examRandomConfigList;
      } else {
        this.exam.examQuestionConfigList = this.examQuestionConfigList;
      }
    } else {
      this.examDimensionConfigList = _.cloneDeep(
        this.exam.examDimensionConfigList
      );
      if (this.isRandom) {
        this.examRandomConfigList = _.cloneDeep(this.exam.examRandomConfigList);
        await this.getRandomQuestionList();
      } else {
        this.examQuestionConfigList = _.cloneDeep(
          this.exam.examQuestionConfigList
        );
      }
    }
  }

  visible = false;
  isRandom = false; //抽题组追问设置
  openVisible() {
    this.visible = true;
    this.isRandom = this.exam.isRandomQuestions === 1;
    this.getQuestionList();
    this.infoAssign(false);
  }

  // 如果追问开关关闭，需要将对应的配置信息清除
  handleNeedAskAppendClose() {
    if (this.isRandom) {
      this.examRandomConfigList.forEach(item => {
        if (item.examQuestionConfig.needAskAppend !== 1) {
          item.examQuestionConfig.appendAskConfig.ruleList = [];
          item.examQuestionConfig.appendAskConfig.defaultTextList = [];
          item.examQuestionConfig.appendMaxAskNumber = 1;
        }
      });
    } else {
      this.examQuestionConfigList.forEach(item => {
        if (item.needAskAppend !== 1) {
          item.appendAskConfig.ruleList = [];
          item.appendAskConfig.defaultTextList = [];
          item.appendMaxAskNumber = 1;
        }
      });
    }
  }

  // 追问保存
  async inquirySubmit() {
    this.handleNeedAskAppendClose();
    this.infoAssign(true);
    this.visible = false;
  }

  // 追问取消
  cancel() {
    this.visible = false;
  }
}
